import { Phone, X } from 'lucide-react';
import Translate from '../shared/Translate';
import WsContainers from '../shared/WsContainers';
import { errorLogEnabled } from '../shared/Utils';

const PlaceCall = ({
  callFrom,
  setCallFrom,
  callAs,
  setCallAs,
  callTo,
  setCallTo,
  setProvidedNumber,
  expanded,
  toggleSection,
  settings,
  credentials,
  container
}) => {
  const handleCall = () => {
    WsContainers.action({
      _class: 'com.optimsys.costra.optimcall.pipedrive.call.Dial',
      credentials: credentials,
      callerNumber: callFrom,
      callerId: callAs === 'Selected by OptimCall' ? undefined : callAs,
      calledNumber: callTo,
    }).then(() => {
      setProvidedNumber('')
      toggleSection()
      container.tell({
        _class: 'com.optimsys.costra.optimcall.pipedrive.user.CurrentUserInfo$CloseFullScreenNotification',
      })
    }).catch((error) => {
      errorLogEnabled && console.error('Error on call dial:', error)
    })
  };

  let sectionBody = expanded && (
    <div 
      className="comm-form-wrapper"
      onClick={event => {
        event.stopPropagation()
        toggleSection()
      }}
    >
      <div 
        className="comm-form"
        onClick={event => event.stopPropagation()}
      >
        <div className='comm-form-close'>
          <X 
            size={16}
            onClick={toggleSection}
          />
        </div>
        <div className="form-group">
          <label className="form-label">{Translate.get('main.call.from')}</label>
          <input
            type="text"
            className="form-input"
            value={callFrom}
            onChange={(e) => {
              let value = e.target.value;
              setCallFrom(value);
              document.cookie = `callFrom=${value}; path=/; SameSite=None; Secure`;
            }}
          />
        </div>

        <div className="form-group">
          <label className="form-label">{Translate.get('main.call.as')}</label>
          <select
            className="form-select"
            value={callAs}
            onChange={(e) => setCallAs(e.target.value)}
          >
            <option value="optimcall">{Translate.get('main.call.as.optimcall')}</option>
            {Object.entries(settings?.callSettings?.lineSettings || []).map(([key, value]) => {
              if (value.isIdentification) {
                return (
                  <option key={key} value={key}>
                    {value.title ? `${key} - ${value.title}` : key}
                  </option>
                );
              }
              return null;
            })}
          </select>
        </div>

        <div className="form-group">
          <label className="form-label">{Translate.get('main.call.to')}</label>
          <input
            type="text"
            className="form-input"
            value={callTo}
            onChange={(e) => {
              setCallTo(e.target.value);
            }}
          />
        </div>

        <button
          className="call-button"
          onClick={handleCall}
          disabled={!callTo || !callFrom}
        >
          <Phone size={18} />
          <span>{Translate.get('main.call.button')}</span>
        </button>
      </div>
    </div>
  )

  return sectionBody;
};

export default PlaceCall;
